import {
    shoppingCart as textShoppingCart,
} from '../../translate/Translate.jsx'

import './tour.scss'
import {useContext} from "react";
import {ItemBagContext} from "../../context/ItemBagContext.jsx";
import {setLocal} from "../../hooks/useStorage/useStorage.jsx";

export const TourFlavorAssistant = () => {
    const {setTour} = useContext(ItemBagContext)
    const handleClose = () => {
        setTour({open: false})
        setLocal('tourFlavor', 'ok')
    }
    return <div className={'tour-flavor-assistant'}>
        <label className={'font-label'}>
            {textShoppingCart.warningTourAssistant}
        </label>
        <div className={'div-button'}>
            <div className={'button'} onClick={handleClose}>
                OK
            </div>
        </div>
    </div>
}
